// rem 基准：与 vue.config.js 中 postcss-px2rem 的 remUnit: 128 对应
// 即设计稿宽度按 1280 计算：1280 宽时 1rem = 128px，页面按视口宽度等比缩放
const remUnit = 128
const designWidth = remUnit * 10 // 1280

function setRem() {
    // 相对设计稿的缩放比例，最大放大 2 倍，避免超宽屏下元素过大
    const scale = Math.min(document.documentElement.clientWidth / designWidth, 2)
    document.documentElement.style.fontSize = remUnit * scale + 'px'
}
// 初始化
setRem()
// 改变窗口大小时重新设置 rem
window.onresize = function() {
    setRem()
}
